const prepareUpdateCallRecord = (mutation, user) => (call) => {
  const id = call?._id;
  const recipientId = call?.recipient?._id;
  const shouldIncludeFavorite = call?.favorite !== undefined && call?.favorite !== null;

  delete call?._id;
  delete call?.contactInfo;
  delete call?.contact?._id;
  delete call?.createdAt;
  delete call?.updatedAt;
  delete call?.updatedBy;
  delete call?.deletedBy;
  delete call?.contacts;
  delete call?.recipient;

  return mutation({
    variables: {
      id,
      email: user.email,
      azureId: user.azure_id,
      input: {
        ...call,
        // Note timestamps and ordering are owned by the call-records subgraph. Send only
        // the note content (and `_id` for notes that already exist) so the server stays
        // authoritative and clients never fight over note order. See FILM-370.
        notes: call?.notes?.map((note) => ({
          ...(note?._id && { _id: note._id }),
          note: note?.note ?? '',
        })),
        ...(shouldIncludeFavorite && { favorite: +call?.favorite }),
        recipientId,
        createdBy: typeof call?.createdBy === 'string' ? call?.createdBy : call?.createdBy?._id,
      },
    },
  });
};

export default prepareUpdateCallRecord;
